import { render, staticRenderFns } from "./SelectCustom.vue?vue&type=template&id=e1064a52&scoped=true&"
import script from "./SelectCustom.vue?vue&type=script&lang=js&"
export * from "./SelectCustom.vue?vue&type=script&lang=js&"
import style0 from "./SelectCustom.vue?vue&type=style&index=0&id=e1064a52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1064a52",
  null
  
)

export default component.exports